/** Display initials for nav avatars (first + last word, or first two chars). */
export function getUserInitials(
  fullName?: string | null,
  email?: string | null
): string {
  const name = fullName?.trim();
  if (name) {
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }
  const mail = email?.trim();
  if (mail) {
    return mail.charAt(0).toUpperCase();
  }
  return 'U';
}
